import type { SerializedUser, SerializedAccreditation } from '../state'

/**
 * Converts a raw Firestore user document into a SerializedUser with
 * plain JS types (Date instead of Timestamp, { latitude, longitude }
 * instead of GeoPoint). This prevents circular-reference issues when
 * storing the profile in Zustand / React state.
 */
export function serializeProfile(
  id: string,
  data: Record<string, any>
): SerializedUser {
  let accreditation: SerializedAccreditation | null = null
  if (data.accreditation) {
    const acc = data.accreditation
    accreditation = {
      type: acc.type,
      level: acc.level,
      fullName: acc.fullName,
      dateOfBirth: acc.dateOfBirth?.toDate?.() ?? new Date(0),
      certificationNumber: acc.certificationNumber,
      optionalMemberId: acc.optionalMemberId ?? null,
      documentUrl: acc.documentUrl,
      status: acc.status,
      submittedAt: acc.submittedAt?.toDate?.() ?? new Date(0),
      reviewedAt: acc.reviewedAt?.toDate?.() ?? null,
      reviewedBy: acc.reviewedBy ?? null,
      ...(acc.registeredEmail ? { registeredEmail: acc.registeredEmail } : {})
    }
  }

  return {
    id,
    displayName: data.displayName ?? '',
    email: data.email ?? '',
    handle: data.handle ?? null,
    suburb: data.suburb ?? null,
    location: data.location
      ? { latitude: data.location.latitude, longitude: data.location.longitude }
      : null,
    role: data.role ?? 'member',
    guidedDiveFlag: data.guidedDiveFlag ?? false,
    profileComplete: data.profileComplete ?? false,
    creditBalance: data.creditBalance ?? 0,
    accreditation,
    bankDetails: data.bankDetails ?? null,
    allowlist: data.allowlist ?? null,
    perfectRatingCount: data.perfectRatingCount ?? null,
    ratingAggregates: data.ratingAggregates ?? null,
    accountStatus: data.accountStatus ?? 'active',
    createdAt: data.createdAt?.toDate?.() ?? new Date(0),
    updatedAt: data.updatedAt?.toDate?.() ?? new Date(0)
  }
}
